import Component from "./StandardList";
export default Component;
